const decodeMessage = (message) => {
  return decodeURIComponent(message.replace(/\+/g, " "));
};

const messageTypeHeaders = (messagetype) => {
  switch (messagetype) {
    case "Success":
      return "success";
    case "Danger":
      return "error";
    case "Warning":
      return "warning";
    case "Info":
      return "info";
    default:
      return "error";
  }
};

export { decodeMessage, messageTypeHeaders };
